// @ts-nocheck
document.addEventListener('alpine:init', function () {
  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
  const currency = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
  });

  const _state = Alpine.reactive({
    data: {
      currency: '',
      attributes: {},
      note: null,
      item_count: 0,
      items: [],
      requires_shipping: false,
      token: '',
      total_price: 0,
      total_weight: 0,
    },
    variantQuantities: {},
    isLoading: false,
    isInitialised: false,
  });

  // @ts-ignore
  Alpine.store('cart', {
    quantities: {},

    get isInitialised() {
      return _state.isInitialised;
    },
    get isLoading() {
      return _state.isLoading;
    },
    get data() {
      return { ..._state.data };
    },
    get currency() {
      return _state.data.currency;
    },
    get attributes() {
      return _state.data.attributes;
    },
    get note() {
      return _state.data.note;
    },
    get requiresShipping() {
      return _state.data.requires_shipping;
    },
    get itemCount() {
      return _state.data.item_count;
    },
    get items() {
      return [..._state.data.items].reverse();
    },
    get totalPrice() {
      return _state.data.total_price;
    },
    get totalWeight() {
      return _state.data.total_weight;
    },
    get upsellItemsCount() {
      return _state.data.items.filter(
        item => item.properties && item.properties._is_upsell === 'true',
      ).length;
    },
    get hasUpsellItems() {
      return this.upsellItemsCount > 0;
    },

    getItem(lineIndex) {
      if (lineIndex < 0 || lineIndex >= _state.data.items.length) {
        return _state.data.items[lineIndex];
      }
      return null;
    },
    getItemPrice(item) {
      return item ? item.price : 0;
    },
    getLinePrice(item) {
      return item ? item.line_price : 0;
    },

    get formattedTotalPrice() {
      return currency.format(_state.data.items_subtotal_price / 100);
    },
    getFormattedItemPrice(item) {
      return item ? currency.format(item.price / 100) : '';
    },
    getFormattedLinePrice(item) {
      return item ? currency.format(item.line_price / 100) : '';
    },

    /**
     * @param {number} id
     * @param {number} quantity
     * @param {Record<string, string>|null} properties
     * @param {string} title
     * @param {boolean} notify
     */
    async addItem(
      id,
      quantity = 1,
      properties = null,
      title = '',
      notify = true,
    ) {
      let addedItem = null;
      try {
        const data = { id, quantity };
        if (properties) {
          data.properties = properties;
        }
        _state.isLoading = true;
        const cart = await jmsf.cart.add({ items: [data] }, true);
        if (notify) {
          addedItem = cart?.items?.find(item => item.variant_id === id);
          let message = 'Item has been added to your basket';
          if (title) {
            message = `"${title}" has been added to your basket`;
          } else if (addedItem) {
            message = `"${this.getProductTitle(
              addedItem,
            )}" has been added to your basket`;
          }
          notyf.success(message);
        }
      } catch (error) {
        console.error(error);
        if (notify) {
          notyf.error('Failed to add item to your basket');
        }
      } finally {
        _state.isLoading = false;
        return addedItem;
      }
    },

    /**
     * @param {} item
     * @param {number|null} quantity
     * @param {boolean} notify
     */
    async updateItemQuantity(key, quantity, notify = true) {
      try {
        _state.isLoading = true;
        await sleep(500);
        const cart = await jmsf.cart.update(
          { updates: { [key]: quantity } },
          true,
        );
        if (notify)
          if (cart && cart.items) {
            const lineItem = cart.items.find(item => item.key === key);
            if (lineItem) {
              _state.isLoading = false;
              return lineItem;
            }
          }
      } catch (error) {
        console.error(error);
        notyf.error('Unable to update item quantity');
      } finally {
        _state.isLoading = false;
        return null;
      }
    },

    /**
     * @param {string} key
     * @param {Record<string,string>} properties
     * @param {boolean} notify
     */
    async updateItemProperties(key, properties, notify = true) {
      try {
        _state.isLoading = true;
        const cart = await jmsf.cart.change({ id: key, properties }, true);
        if (notify) {
          notyf.success('Your basket has been updated');
        }
        if (cart && cart.items) {
          const lineItem = cart.items.find(item => item.key === key);
          if (lineItem) {
            _state.isLoading = false;
            return lineItem;
          }
        }
      } catch (error) {
        console.error(error);
        notyf.error('Unable to update item');
      } finally {
        _state.isLoading = false;
        return null;
      }
    },

    async removeItem(item, notify = true) {
      try {
        _state.isLoading = true;
        /**
         * If there are only two items left, and one of them is a
         * delivery surcharge product, just clear the cart instead
         * to avoid an orphaned surcharge.
         */
        let isLastItemWithSurcharge = false;
        if (_state.data?.item_count === 2) {
          _state.data.items.forEach(item => {
            if (this.isDeliverySurcharge(item)) {
              isLastItemWithSurcharge = true;
            }
          });
        }
        if (isLastItemWithSurcharge) {
          await jmsf.cart.clear();
        } else {
          await jmsf.cart.remove(item.key, true);
        }

        if (notify) {
          notyf.success(
            `${this.getProductTitle(item)} has been removed from your basket`,
          );
        }

        if (isLastItemWithSurcharge) {
          window.location.reload();
        }
      } catch (error) {
        console.error(error);
        if (notify) {
          notyf.error('Failed to remove item from cart');
        }
      } finally {
        _state.isLoading = false;
      }
    },

    // -- Max quantities --------

    /**
     * @param {string[]} variantQuantities
     */
    setVariantMaxQuantities(variantQuantities) {
      if (variantQuantities) {
        variantQuantities.forEach(vq => {
          const [id, quantity] = vq.split(':');
          _state.variantQuantities[id] = quantity;
        });
      }
    },

    /**
     * @param {number} variantId
     * @return {number}
     */
    getVariantMaxQuantity(variantId) {
      const max = _state.variantQuantities[variantId];
      if (max) {
        return max;
      }
      return 20;
    },

    getItemMaxQuantity(item) {
      return this.getVariantMaxQuantity(item.variant_id);
    },

    // -- Quantity updates --------

    hasQuantityData(item) {
      return this.quantities[item.key] !== undefined;
    },

    // Clear one or all timeouts
    clearQuantityUpdateTimeouts(item = null) {
      if (item) {
        if (this.quantities[item.key]?.updateTimeout) {
          clearTimeout(this.quantities[item.key].updateTimeout);
          this.quantities[item.key].updateTimeout = null;
        }
      } else {
        Object.keys(this.quantities).forEach(key => {
          if (this.quantities[key].updateTimeout !== null) {
            clearTimeout(this.quantities[key].updateTimeout);
            this.quantities[key].updateTimeout = null;
          }
        });
      }
    },

    onItemQuantityChange(item) {
      if (this.hasQuantityData(item)) {
        const oldQuantity = item.quantity;
        let newQuantity = parseInt(this.quantities[item.key].current);
        const maxQuantity = this.getItemMaxQuantity(item);
        if (newQuantity < 1 || isNaN(newQuantity)) {
          newQuantity = 1;
          this.quantities[item.key].current = newQuantity;
        } else if (newQuantity > maxQuantity) {
          newQuantity = maxQuantity;
          this.quantities[item.key].current = newQuantity;
        }
        this.clearQuantityUpdateTimeouts(item);
        if (oldQuantity != newQuantity) {
          this.quantities[item.key].updateTimeout = setTimeout(async () => {
            await this.updateItemQuantity(item.key, newQuantity);
          }, 600);
        }
      }
    },

    canIncrementItem(item) {
      if (this.hasQuantityData(item)) {
        const quantity = parseInt(this.quantities[item.key].current);
        const maxQuantity = this.getItemMaxQuantity(item);
        return quantity < maxQuantity;
      }
      return false;
    },

    canDecrementItem(item) {
      if (this.hasQuantityData(item)) {
        const quantity = parseInt(this.quantities[item.key].current);
        return quantity > 1;
      }
      return false;
    },

    incrementItem(item) {
      if (this.canIncrementItem(item)) {
        this.quantities[item.key].current++;
        this.onItemQuantityChange(item);
      }
    },

    decrementItem(item) {
      if (this.canDecrementItem(item)) {
        this.quantities[item.key].current--;
        this.onItemQuantityChange(item);
      }
    },

    // -- Property updates --------

    /**
     * Check if an item/product supports a wholesale addon. Flags
     * are set in cart item props when adding to cart to show what
     * addons it supports.
     */
    supportsWholesaleAddon(item, addonKey) {
      const propertyKey = `_supports_ws_addon_${addonKey}`;
      return !!item.properties?.[propertyKey];
    },

    // True if product supports the addon and customer is wholesale customer.
    canAddWholesaleAddon(item, addonKey) {
      return window.isWholesaleCustomer && this.supportsWholesaleAddon(item, addonKey);
    },

    hasWholesaleAddon(item, addonKey) {
      const addonsProp = item.properties['free-addons'];
      return addonsProp?.includes(addonKey) || addonsProp === 'both';
    },

    /**
     * Add a wholesale POS addon. If both are selected, the
     * resulting value will be "both".
     * 
     * TODO this is quite janky with the "both" system and
     * TODO makes it more complex. It would required business
     * TODO changes but it would be better to just have them
     * TODO as separate properties.
     */
    addWholesaleAddon(item, addonType) {
      let addonValue = addonType;
      // Maybe modify to 'both'
      if (
        (addonType === 'pos_cards' &&
          this.hasWholesaleAddon(item, 'greaseproof_papers')) ||
        (addonType === 'greaseproof_papers' &&
          this.hasWholesaleAddon(item, 'pos_cards'))
      ) {
        addonValue = 'both';
      }
      this.updateItemProperties(item.key, {
        ...item.properties,
        ['free-addons']: addonValue,
      });
    },

    /**
     * Remove a wholesale POS addon. If both are selected,
     * the resulting value will be the remaining addon.
     */
    removeWholesaleAddon(item, addonType) {
      let addonValue = null;
      // Maybe modify 'both' to single value
      if (
        addonType === 'pos_cards' &&
        this.hasWholesaleAddon(item, 'greaseproof_papers')
      ) {
        addonValue = 'greaseproof_papers';
      } else if (
        addonType === 'greaseproof_papers' &&
        this.hasWholesaleAddon(item, 'pos_cards')
      ) {
        addonValue = 'pos_cards';
      }
      this.updateItemProperties(item.key, {
        ...item.properties,
        ['free-addons']: addonValue,
      });
    },

    // -- Item helpers --------

    getProductTitle(item) {
      return item.product_title;
    },

    isDeliverySurcharge(item) {
      return (
        item.product_title.includes('delivery') ||
        item.product_type?.includes('Delivery Surcharge')
      );
    },

    isCake(item) {
      return item.product_type.toLowerCase() === 'cake';
    },

    isGiftCard(item) {
      return item.product_type === 'Gift Card';
    },

    // -- Internal --------

    _syncFromCart() {
      if (jmsf && jmsf.cart) {
        const data = jmsf.cart.getData();
        if (data && data.items !== undefined) {
          _state.data = { ...data };

          // -- Sync quantity edit record --------
          this.clearQuantityUpdateTimeouts();
          // Clone, don't remove old/removed keys, can cause bugs
          const updatedQuantities = { ...this.quantities };
          for (item of data.items) {
            updatedQuantities[item.key] = {
              initial: item.quantity,
              current: item.quantity,
              updateTimeout: null,
            };
          }
          this.quantities = updatedQuantities;

          if (!_state.isInitialised) {
            window.dispatchEvent(new Event('alpine:cart:ready'));
            _state.isInitialised = true;
          }
        }
      }
      _state.isLoading = false;
    },

    _clearLoadingState() {
      _state.isLoading = false;
    },

    init() {
      // Ensure loading reset on all errors
      window.addEventListener(
        'shop::cart:add:error',
        this._clearLoadingState.bind(this),
      );
      window.addEventListener(
        'shop::cart:change:error',
        this._clearLoadingState.bind(this),
      );
      window.addEventListener(
        'shop::cart:update:error',
        this._clearLoadingState.bind(this),
      );
      window.addEventListener(
        'shop::cart:clear:error',
        this._clearLoadingState.bind(this),
      );
      window.addEventListener(
        'shop::cart:remove:error',
        this._clearLoadingState.bind(this),
      );

      // Sync internal data on all updates
      window.addEventListener(
        'shop::cart:data:updated',
        this._syncFromCart.bind(this),
      );
      this._syncFromCart();
    },
  });
});
